import React from 'react';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
  const isLogin = localStorage.getItem('vendor_dashboard');
  
  return isLogin ? <Navigate to="/dashboard" /> : children;
};

export default PublicRoute;